<div class="inline-number-wrapper">
  @if (!isEditing) {
    <span class="left">
      @if (!selectedValue) {
        <a (click)="toggleEdit()" class="add"> Select Outcome </a>
      }
      <span>
        {{ formattedAnswer }}
      </span>
      @if (selectedValue) {
        <button class="edit-button" mat-icon-button (click)="startEdit()">
          <mat-icon class="edit-icon">edit</mat-icon>
        </button>
      }
    </span>
  }
  <div
    class="editing"
    [ngClass]="{
      hidden: !isEditing
    }"
    >
    <form [formGroup]="form">
      <mat-button-toggle-group id="chairReviewOutcome" formControlName="chairReviewOutcome" name="chairReviewOutcome">
        <mat-button-toggle value="REC">Reconsider</mat-button-toggle>
        <mat-button-toggle value="STAY">Stay</mat-button-toggle>
      </mat-button-toggle-group>
    </form>
    <div class="button-container">
      <button mat-button (click)="toggleEdit()">CANCEL</button>
      <button mat-button class="save" (click)="onSave()">SAVE</button>
    </div>
  </div>
</div>
